import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy( () => import("../components/errorPage/main"));

const ErrorPage = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default ErrorPage;